import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const MainSortInputSearch = ({placeholder}) => {

  const {pathname} = useLocation();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');

  const changeHandler = (e) => {setSearchValue(e.target.value)};

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (searchValue !== '') {
      params.set('search', searchValue)
    } else {
      params.delete('search')
    }

    navigate(`${pathname}?${params.toString()}`, { replace: true });
  }, [searchValue])

  useEffect(() => {
    setSearchValue('');
  }, [pathname])

  return (
    <fieldset className="gradient-block__search-input-wrapper">
      <input type="search" className="gradient-block__search-input" placeholder={placeholder} onInput={changeHandler} value={searchValue} />
      {
        searchValue !== '' && (
          <button type="reset" className='gradient-block__search-input-reset' onClick={() => setSearchValue('')}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 9L9 15M15 15L9 9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#ffffff" strokeWidth="1.4" strokeLinecap="square" />
          </svg>
        </button>
      )}
    </fieldset>
  )
}

export default MainSortInputSearch;
